
import 'firebase/compat/firestore'
import firebase from 'firebase/compat/app'


const firebaseConfig = {
  apiKey: "AIzaSyDof_4LWFWpsYLey2oUXac0FyxztAQljuY",
  authDomain: "shells-stories-901f0.firebaseapp.com",
  projectId: "shells-stories-901f0",
  storageBucket: "shells-stories-901f0.firebasestorage.app",
  messagingSenderId: "1079850900653",
  appId: "1:1079850900653:web:38604e3489cfd615023a24",
  measurementId: "G-WFJ2TRWN14"
};

//   const app = initializeApp(firebaseConfig);
const app = firebase.initializeApp(firebaseConfig)

  export const admin = firebase;
  export const db = app.firestore();
//   export const auth = app.auth();
//   export const storage = app.storage();
//   export const database = app.database()
  export default app  